import React, { useState, useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./css/timeline.css";
import Modal from "./infoimodal";
import { API_BASE_URL, authHeaders } from "../api";

function Timeline() {

    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {

        async function loadCV() {

            const res = await fetch(`${API_BASE_URL}/api/cv`, {
                headers: authHeaders()
            });

            const data = await res.json();
            setItems(data);
        }

        loadCV();

    }, []);

    return (
        <>

            {/* Modal nur für Desktop */}
            <Modal item={selectedItem} />

            {/* DESKTOP TIMELINE */}
            <div className="timeline-desktop">
                <div className="timeline-container">
                    <div className="timeline-line">

                        {items.map((item, index) => (
                            <div
                                key={index}
                                className="timeline-item"
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"
                                onClick={() => setSelectedItem(item)}
                            >

                                {index % 2 === 0 && (
                                    <div className="timeline-text top">
                                        <h5>{item.year}</h5>
                                        <p>{item.title}</p>
                                    </div>
                                )}

                                <div
                                    className="timeline-dot"
                                    data-bs-toggle="tooltip"
                                    data-bs-title={item.tooltip}
                                ></div>

                                {index % 2 !== 0 && (
                                    <div className="timeline-text bottom">
                                        <h5>{item.year}</h5>
                                        <p>{item.title}</p>
                                    </div>
                                )}

                            </div>
                        ))}

                    </div>
                </div>
            </div>


            {/* MOBILE ACCORDION */}
            <div className="timeline-mobile container">

                <div
                    className="accordion"
                    id="timelineAccordion"
                    style={{ display: "flex", flexDirection: "column-reverse" }}
                >
                    {items.map((item, index) => (

                        <div className="accordion-item" key={index}>

                            <h2 className="accordion-header">

                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse${index}`}
                                >
                                    {item.year} - {item.title}
                                </button>

                            </h2>

                            <div
                                id={`collapse${index}`}
                                className="accordion-collapse collapse"
                                data-bs-parent="#timelineAccordion"
                            >

                                <div className="accordion-body">

                                    {/* HIER KOMMT DER MODAL INHALT REIN */}
                                    <p>{item.tooltip}</p>

                                    {item.description && (
                                        <p>{item.description}</p>
                                    )}

                                    {item.company && (
                                        <p><strong>Firma:</strong> {item.company}</p>
                                    )}

                                </div>

                            </div>

                        </div>

                    ))}

                </div>

            </div>

        </>
    );
}

export default Timeline;
